import { useLocation } from 'root/src/client/v2/browser/hooks/useLocation';
export const WindowAdapter = ({ children }) => {
    const windowAdapter = useWindowAdapter();
    return children(windowAdapter);
};
export function useWindowAdapter() {
    const { search } = useLocation();
    return {
        push: updateLocation,
        replace: updateLocation,
        get location() {
            return { search };
        },
    };
}
function updateLocation(location) {
    const searchParams = withoutUndefined(location.search);
    window.history.replaceState({}, '', `${window.location.pathname}?${searchParams}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
}
function withoutUndefined(search) {
    const params = new URLSearchParams(search);
    params.forEach((value, key) => {
        if (value === 'undefined' || value === 'null'
            || value === null || value === undefined || value === '') {
            params.delete(key);
        }
    });
    return params.toString();
}
